import React from 'react';
import { Form, Select, Radio } from 'antd';
import {
  LEARNING_MODE_OPTIONS,
  PREFERRED_LANGUAGE_OPTIONS
} from '../../../../Utils/sriLankaGeoData';

const { Option } = Select;

const Section07Preferences = () => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 07</span>
        <h3>Learning Preferences</h3>
        <p className="section-description">
          Tell us how and when you prefer to study so we can assign suitable batches and lecture timings.
        </p>
      </div>

      <div className="form-grid">
        <Form.Item
          label="Preferred Learning Mode"
          name="preferredLearningMode"
          rules={[{ required: true, message: 'Please select your preferred learning mode' }]}
          initialValue="online_zoom"
        >
          <Radio.Group buttonStyle="solid" size="large" className="learning-mode-radios">
            {LEARNING_MODE_OPTIONS.map((opt) => (
              <Radio.Button key={opt.value} value={opt.value}>
                {opt.label}
              </Radio.Button>
            ))}
          </Radio.Group>
        </Form.Item>

        <div className="grid-two-cols">
          <Form.Item label="Preferred Class Time (Optional)" name="preferredClassTime">
            <Select size="large" placeholder="Select preferred class schedule">
              <Option value="weekday_evening">Weekday Evenings (6:30 PM – 9:30 PM)</Option>
              <Option value="weekend_morning">Weekend Mornings (8:30 AM – 1:30 PM)</Option>
              <Option value="weekend_afternoon">Weekend Afternoons (2:00 PM – 7:00 PM)</Option>
              <Option value="sunday_only">Sunday Full-Day Sessions</Option>
              <Option value="flexible">Flexible / Recorded Self-Paced</Option>
            </Select>
          </Form.Item>

          <Form.Item label="Preferred Course Duration (Optional)" name="preferredCourseDuration">
            <Select size="large" placeholder="Select preferred course length">
              <Option value="short_intensive">Short Intensive Workshops (2 – 4 Weeks)</Option>
              <Option value="certificate_standard">Standard Certificate Course (2 – 3 Months)</Option>
              <Option value="diploma">Executive Diploma (4 – 6 Months)</Option>
              <Option value="advanced_diploma">Advanced Diploma / Extended (9 – 12 Months)</Option>
            </Select>
          </Form.Item>
        </div>

        <Form.Item
          label="Preferred Instruction Language"
          name="preferredLanguage"
          extra="Recommended"
          initialValue="english"
        >
          <Select size="large" placeholder="Select preferred language">
            {PREFERRED_LANGUAGE_OPTIONS.map((lang) => (
              <Option key={lang.value} value={lang.value}>
                {lang.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </div>
    </div>
  );
};

export default Section07Preferences;
